<template>
  <div class="location-page">
    <!-- Hero sectie -->
    <div class="hero-section">
      <div class="container">
        <h1>Tandarts Boxtel | Tandzorg Gestel | Dichtbij Boxtel en Liempde</h1>
        <p class="lead">
          Op zoek naar een betrouwbare <strong>tandarts bij Boxtel</strong>? Tandzorg Gestel in Sint-Michielsgestel 
          ligt op slechts 12 minuten van Boxtel centrum. Ervaren tandheelkundige zorg met persoonlijke aandacht 
          en moderne technieken.
        </p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Waarom kiezen patiënten uit Boxtel voor Tandzorg Gestel?</h2>
            <p>
              Inwoners van <em>Boxtel</em>, <em>Liempde</em>, <em>Best</em> en <em>Oirschot</em> waarderen onze nabije 
              locatie en persoonlijke benadering. Hoewel we net buiten Boxtel liggen, bieden we voordelen die 
              veel grote praktijken in de stad niet kunnen evenaren.
            </p>

            <div class="highlight-box">
              <h3>🎯 Waarom Tandzorg Gestel vanuit Boxtel?</h3>
              <div class="row">
                <div class="col-md-6">
                  <ul class="benefits-list">
                    <li><strong>Dichterbij dan u denkt</strong> - 12 minuten vanuit Boxtel centrum</li>
                    <li><strong>Geen parkeerstress</strong> - Ruime gratis parking</li>
                    <li><strong>Persoonlijke zorg</strong> - Geen haast, alle tijd voor u</li>
                    <li><strong>Vaste behandelaar</strong> - Continuïteit in uw zorg</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul class="benefits-list">
                    <li><strong>Moderne apparatuur</strong> - Laatste technieken</li>
                    <li><strong>Flexibele tijden</strong> - Ook avonden en zaterdag</li>
                    <li><strong>Complete zorg</strong> - Van preventie tot specialisme</li>
                    <li><strong>Familiepraktijk</strong> - Alle leeftijden welkom</li>
                  </ul>
                </div>
              </div>
            </div>

            <h2>Route en bereikbaarheid vanuit Boxtel</h2>
            <p>Tandzorg Gestel is vanuit verschillende delen van de gemeente Boxtel goed bereikbaar:</p>

            <div class="route-section">
              <div class="row">
                <div class="col-md-6">
                  <div class="route-card">
                    <h4>🚗 Met de auto</h4>
                    <ul>
                      <li><strong>Vanuit Boxtel centrum:</strong><br>Via A2 noord, afslag Sint-Michielsgestel (12 min)</li>
                      <li><strong>Vanuit Liempde:</strong><br>Via Bosscheweg naar A2, afslag Sint-Michielsgestel (10 min)</li>
                      <li><strong>Vanuit Best:</strong><br>Via A2 noord naar afslag Sint-Michielsgestel (18 min)</li>
                      <li><strong>Vanuit Oirschot:</strong><br>Via N69 naar A2, afslag Sint-Michielsgestel (20 min)</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="route-card">
                    <h4>🚌 Openbaar vervoer</h4>
                    <ul>
                      <li><strong>Trein + bus:</strong><br>Trein Boxtel → Den Bosch<br>Bus naar Sint-Michielsgestel (35 min)</li>
                      <li><strong>Directe bus:</strong><br>Lijn 20 via Vught naar Sint-Michielsgestel (40 min)</li>
                      <li><strong>Fiets:</strong><br>Mooie route via het Dommelpad (45 min)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <h2>Complete tandheelkundige zorg voor Boxtel</h2>
            <p>
              Voor patiënten uit de regio Boxtel bieden we een breed scala aan tandheelkundige behandelingen, 
              van routine controles tot gespecialiseerde procedures:
            </p>

            <div class="services-grid">
              <div class="row">
                <div class="col-lg-3 col-md-6">
                  <div class="service-item">
                    <div class="service-icon">🦷</div>
                    <h4>Algemene Zorg</h4>
                    <ul>
                      <li>Halfjaarlijkse controles</li>
                      <li>Professionele reiniging</li>
                      <li>Vullingen en reparaties</li>
                      <li>Kronen en bruggen</li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="service-item">
                    <div class="service-icon">✨</div>
                    <h4>Cosmetiek</h4>
                    <ul>
                      <li>Tandenbleken</li>
                      <li>Veneers</li>
                      <li>Composite bonding</li>
                      <li>Glimlach design</li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="service-item">
                    <div class="service-icon">🔬</div>
                    <h4>Specialismen</h4>
                    <ul>
                      <li>Wortelkanaal behandeling</li>
                      <li>Parodontologie</li>
                      <li>Implantologie</li>
                      <li>Orthodontie</li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="service-item">
                    <div class="service-icon">👨‍👩‍👧‍👦</div>
                    <h4>Familie</h4>
                    <ul>
                      <li>Kindertandheelkunde</li>
                      <li>Zwangerschapszorg</li>
                      <li>Seniorenzorg</li>
                      <li>Angstpatiënten</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <h2>Wat onze patiënten uit Boxtel zeggen</h2>
            <div class="testimonials-section">
              <div class="row">
                <div class="col-md-6">
                  <div class="testimonial">
                    <div class="rating">⭐⭐⭐⭐⭐</div>
                    <blockquote>
                      "Ik kom al jaren vanuit Boxtel naar Tandzorg Gestel. De reistijd is minimaal, 
                      maar het verschil in service is enorm. Eindelijk een tandarts die tijd voor je neemt!"
                    </blockquote>
                    <cite>- Sandra M., Boxtel</cite>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="testimonial">
                    <div class="rating">⭐⭐⭐⭐⭐</div>
                    <blockquote>
                      "Vanuit Liempde perfect bereikbaar. Modern ingerichte praktijk en erg vriendelijk personeel. 
                      Ook voor mijn kinderen een toplocatie!"
                    </blockquote>
                    <cite>- Peter V., Liempde</cite>
                  </div>
                </div>
              </div>
            </div>

            <h2>Praktische informatie voor Boxtel</h2>
            <div class="practical-info">
              <div class="row">
                <div class="col-md-4">
                  <div class="info-block">
                    <h4>⏰ Afspraaktijden</h4>
                    <p>Wij begrijpen dat u vanuit Boxtel komt, daarom bieden we:</p>
                    <ul>
                      <li>Flexibele afspraaktijden</li>
                      <li>Avondafspraken mogelijk</li>
                      <li>Zaterdagochtend geopend</li>
                      <li>Online afspraken 24/7</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="info-block">
                    <h4>🚗 Parkeer Service</h4>
                    <p>Voor onze patiënten uit Boxtel:</p>
                    <ul>
                      <li>Gratis parkeren</li>
                      <li>Ruime parkeerplaatsen</li>
                      <li>Direct voor de praktijk</li>
                      <li>Geen parkeerschijf nodig</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="info-block">
                    <h4>📞 Contact</h4>
                    <p>Gemakkelijk bereikbaar:</p>
                    <ul>
                      <li>Telefonische afspraken</li>
                      <li>WhatsApp mogelijk</li>
                      <li>Email voor vragen</li>
                      <li>Spoedlijn beschikbaar</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="cta-section">
              <h2>Klaar om kennis te maken?</h2>
              <p>
                Overweegt u om over te stappen naar een tandartspraktijk die écht tijd voor u heeft? 
                Maak een vrijblijvende kennismakingsafspraak en ervaar het verschil van persoonlijke tandheelkundige zorg.
              </p>
              <div class="cta-buttons">
                <router-link to="/afspraak-maken" class="btn btn-primary">
                  <i class="fas fa-calendar-plus"></i> Afspraak Maken
                </router-link>
                <router-link to="/contact" class="btn btn-secondary">
                  <i class="fas fa-phone"></i> Eerst Bellen
                </router-link>
              </div>
            </div>
          </div>

          <!-- Sidebar -->
          <div class="col-md-4">
            <div class="sidebar">
              <div class="contact-card">
                <h3>📍 Bereikbaarheid</h3>
                <div class="contact-info">
                  <p><strong>Adres:</strong><br>Dr. Erensstraat 45<br>5271 BC Sint-Michielsgestel</p>
                  <p><strong>Telefoon:</strong><br>073 - 551 4004</p>
                  <p><strong>Afstand vanuit Boxtel:</strong><br>12 minuten rijden</p>
                </div>
              </div>

              <div class="hours-card">
                <h3>🕒 Openingstijden</h3>
                <div class="hours-grid">
                  <div class="hours-row">
                    <span class="day">Maandag</span>
                    <span class="time">8:00 - 17:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Dinsdag</span>
                    <span class="time">8:00 - 20:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Woensdag</span>
                    <span class="time">8:00 - 17:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Donderdag</span>
                    <span class="time">8:00 - 20:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Vrijdag</span>
                    <span class="time">8:00 - 17:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Zaterdag</span>
                    <span class="time">9:00 - 13:00</span>
                  </div>
                  <div class="hours-row">
                    <span class="day">Zondag</span>
                    <span class="time">Gesloten</span>
                  </div>
                </div>
              </div>

              <div class="specialties-card">
                <h3>🏆 Onze Specialiteiten</h3>
                <ul class="specialties-list">
                  <li>✓ Lid van De Lieve Tandarts</li>
                  <li>✓ Digitale tandheelkunde</li>
                  <li>✓ Pijn-vrije behandelingen</li>
                  <li>✓ Kindvriendelijke praktijk</li>
                  <li>✓ Moderne apparatuur</li>
                  <li>✓ Ervaren specialisten</li>
                </ul>
              </div>

              <div class="emergency-card">
                <h3>🚨 Spoedgevallen</h3>
                <p>Tandpijn of spoedgeval? Ook vanuit Boxtel helpen we u snel.</p>
                <router-link to="/spoed" class="emergency-btn">
                  <i class="fas fa-exclamation-triangle"></i> Spoedhulp
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TandartsBoxtel',
  mounted() {
    document.title = 'Tandarts Boxtel | Tandzorg Gestel Sint-Michielsgestel | 12 Min Rijden'
    
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        'Tandarts Boxtel? Tandzorg Gestel in Sint-Michielsgestel ligt op 12 minuten van Boxtel. Persoonlijke zorg, moderne technieken, gratis parkeren. Ook Liempde, Best en Oirschot.')
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 
        'tandarts Boxtel, tandarts 5281, tandarts Liempde, tandarts Best, tandarts Oirschot, tandheelkunde Boxtel, Sint-Michielsgestel, Tandzorg Gestel')
    }
  }
}
</script>

<style scoped>
.location-page {
  padding-top: 120px;
}

.hero-section {
  background: linear-gradient(135deg, #fff7e6 0%, #e8f4fd 100%);
  padding: 60px 0;
  margin-bottom: 40px;
}

.hero-section h1 {
  font-size: 2.5rem;
  color: var(--black);
  margin-bottom: 1rem;
  font-weight: 700;
}

.lead {
  font-size: 1.3rem;
  line-height: 1.6;
  color: var(--light-color);
}

.highlight-box {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
  padding: 2rem;
  border-radius: 12px;
  margin: 2rem 0;
  border-left: 4px solid var(--blue);
}

.highlight-box h3 {
  color: var(--blue);
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
}

.benefits-list {
  list-style: none;
  padding: 0;
}

.benefits-list li {
  padding: 0.5rem 0;
  color: var(--light-color);
  position: relative;
  padding-left: 1.5rem;
}

.benefits-list li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--blue);
  font-weight: bold;
}

.route-section {
  margin: 3rem 0;
}

.route-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  height: 100%;
}

.route-card h4 {
  color: var(--blue);
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
}

.route-card ul {
  list-style: none;
  padding: 0;
}

.route-card li {
  padding: 0.8rem 0;
  border-bottom: 1px solid #f0f0f0;
  color: var(--light-color);
}

.route-card li:last-child {
  border-bottom: none;
}

.route-card strong {
  color: var(--black);
}

.services-grid {
  margin: 3rem 0;
}

.service-item {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  text-align: center;
  margin-bottom: 2rem;
  transition: transform 0.3s ease;
}

.service-item:hover {
  transform: translateY(-5px);
}

.service-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.service-item h4 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.service-item ul {
  list-style: none;
  padding: 0;
  text-align: left;
}

.service-item li {
  padding: 0.3rem 0;
  color: var(--light-color);
  position: relative;
  padding-left: 1rem;
}

.service-item li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: var(--blue);
}

.testimonials-section {
  margin: 3rem 0;
}

.testimonial {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
  border-left: 4px solid var(--blue);
}

.rating {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.testimonial blockquote {
  font-style: italic;
  color: var(--light-color);
  line-height: 1.6;
  margin: 1rem 0;
}

.testimonial cite {
  color: var(--blue);
  font-weight: 600;
  font-style: normal;
}

.practical-info {
  margin: 3rem 0;
}

.info-block {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.info-block h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.info-block ul {
  list-style: none;
  padding: 0;
}

.info-block li {
  padding: 0.3rem 0;
  color: var(--light-color);
}

.cta-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
  padding: 3rem;
  border-radius: 12px;
  text-align: center;
  margin: 3rem 0;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: var(--blue);
  color: white;
  border: 2px solid var(--blue);
}

.btn-primary:hover {
  background: var(--dark-blue);
  transform: translateY(-2px);
}

.btn-secondary {
  background: white;
  color: var(--blue);
  border: 2px solid var(--blue);
}

.btn-secondary:hover {
  background: var(--blue);
  color: white;
}

/* Sidebar Styles */
.sidebar {
  position: sticky;
  top: 130px;
}

.contact-card,
.hours-card,
.specialties-card,
.emergency-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.contact-card h3,
.hours-card h3,
.specialties-card h3,
.emergency-card h3 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.hours-grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hours-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.hours-row:last-child {
  border-bottom: none;
}

.day {
  font-weight: 600;
  color: var(--black);
}

.time {
  color: var(--light-color);
}

.specialties-list {
  list-style: none;
  padding: 0;
}

.specialties-list li {
  padding: 0.4rem 0;
  color: var(--light-color);
}

.emergency-card {
  background: linear-gradient(135deg, #fff5f5 0%, #ffebee 100%);
  text-align: center;
}

.emergency-btn {
  background: #dc3545;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.emergency-btn:hover {
  background: #c82333;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .location-page {
    padding-top: 100px;
  }
  
  .hero-section h1 {
    font-size: 2rem;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 100%;
    max-width: 250px;
    justify-content: center;
  }
  
  .sidebar {
    position: static;
    margin-top: 3rem;
  }
  
  .highlight-box,
  .route-card,
  .info-block {
    padding: 1.5rem;
  }
}
</style>
